// Module
var code = "<div class=\"customers\">\n  <dashboard></dashboard>\n</div>\n";
// Exports
module.exports = code;